import React from 'react';

import TimeSeriesChart, {
    TimeSeriesProps,
} from 'utils/components/TimeSeriesChart/TimeSeriesChart';
import './TileTimeSeriesChart.scss';

export function TileTimeSeriesChart(props: TimeSeriesProps) {
    const nextProps = { ...props };
    nextProps.className = `${props.className} TileTimeSeriesChart`;
    return <TimeSeriesChart {...nextProps} suppressZoom={true} />;
}
